module.exports = __webpack_public_path__ + "static/img/13.d40dd9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/13.jpg
// module id = V4u9
// module chunks = 0